import aiApi from 'common/src/modules/ai/ai.api';
import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {askKnowledgeRAGToolSchema} from '../../copilot.schemas';
import {ToolExecuteParams, ToolResult} from '../../copilot.types';
import tool from '../../utils/creators/tool';
import toolResult from '../../utils/creators/toolResult';
import buildKnowledgeRAGToolName from './utils/buildKnowledgeRAGToolName';
import formatFullAnswer from './utils/formatFullAnswer';
import formatRawResources from './utils/formatRawResources';

type AskKnowledgeRAGToolParams = {
  knowledgeTopics: KnowledgeRagTopic[];
  includeFullAnswer?: boolean;
  nameSuffix?: string;
};

function askKnowledgeRAGTool({
  knowledgeTopics,
  includeFullAnswer = false,
  nameSuffix,
}: AskKnowledgeRAGToolParams) {
  async function execute({
    input: {prompt, additionalInfo},
    toolUtils: {abortSignal},
  }: ToolExecuteParams<typeof askKnowledgeRAGToolSchema>): Promise<ToolResult> {
    if (knowledgeTopics.length === 0) {
      return toolResult('No knowledge topics configured.');
    }

    const response = await aiApi.askKnowledgeRAG({
      prompt,
      context: additionalInfo,
      knowledgeTopics,
      includeFullAnswer,
      abortSignal,
    });

    const formattedContent = includeFullAnswer
      ? formatFullAnswer(response)
      : formatRawResources(response);

    return toolResult(formattedContent);
  }

  const topicsList = knowledgeTopics.join(', ');
  const description = `Gather detailed information, best-practices and guidelines for the following subjects: ${topicsList}.`;

  return tool({
    name: buildKnowledgeRAGToolName(nameSuffix),
    displayName: 'Gathering information',
    description,
    execute,
    inputSchema: askKnowledgeRAGToolSchema,
    isReadonly: true,
  });
}

export default askKnowledgeRAGTool;
